exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".subscribe-to-newsletter-form .subscribe-to-newsletter-btn{height:100%;background-color:#526467;color:#fff;border:none}.subscribe-to-newsletter-form .subscribe-to-newsletter-email input{background-color:hsla(0,0%,100%,.2);color:#fff}.subscribe-to-newsletter-form .subscribe-to-newsletter-email input::placeholder{color:#fff}", ""]);

// exports
